import React, { Fragment } from "react";
import { connect } from "react-redux";
import Hamburger from "../../components/common/Hamburger";

import {
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../actions/ThemeAction";

class AppMobileMenu extends React.Component {

  toggleMobileSidebar = () => {
    const { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };

  render() {
    const { enableMobileMenu = false } = this.props;

    return (
      <Fragment>
        <div className="app-header__menu">
          <Hamburger
            active={enableMobileMenu}
            type="elastic"
            onClick={this.toggleMobileSidebar}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: (enable) =>
    dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppMobileMenu);
